import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ce107ad"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "cell-title-container" }
const _hoisted_3 = { class: "cell-text-container" }
const _hoisted_4 = { class: "name-row" }
const _hoisted_5 = { class: "van-ellipsis name-slot" }
const _hoisted_6 = {
  key: 0,
  class: "badge badge-orange"
}
const _hoisted_7 = { class: "status-row" }
const _hoisted_8 = {
  key: 0,
  class: "badge badge-gray"
}
const _hoisted_9 = {
  key: 1,
  class: "badge badge-blue"
}
const _hoisted_10 = {
  key: 2,
  class: "badge badge-blue"
}
const _hoisted_11 = {
  key: 0,
  class: "badge badge-red"
}
const _hoisted_12 = {
  key: 1,
  class: "badge badge-blue"
}
const _hoisted_13 = {
  key: 2,
  class: "badge badge-blue"
}
const _hoisted_14 = { class: "cell-slot-text" }
const _hoisted_15 = { class: "cell-title-container" }
const _hoisted_16 = { class: "cell-text-container" }
const _hoisted_17 = { class: "name-row" }
const _hoisted_18 = { class: "van-ellipsis name-slot" }
const _hoisted_19 = {
  key: 0,
  class: "badge badge-orange"
}
const _hoisted_20 = { class: "status-row" }
const _hoisted_21 = {
  key: 0,
  class: "badge badge-blue"
}
const _hoisted_22 = {
  key: 1,
  class: "badge badge-red"
}
const _hoisted_23 = {
  key: 2,
  class: "badge badge-red"
}
const _hoisted_24 = {
  key: 3,
  class: "badge badge-blue"
}
const _hoisted_25 = { class: "cell-slot-text" }
const _hoisted_26 = { class: "cell-title-container" }
const _hoisted_27 = { class: "cell-text-container" }
const _hoisted_28 = { class: "name-row" }
const _hoisted_29 = { class: "van-ellipsis name-slot" }
const _hoisted_30 = {
  key: 0,
  class: "badge badge-orange"
}
const _hoisted_31 = { class: "status-row" }
const _hoisted_32 = {
  key: 0,
  class: "badge badge-blue"
}
const _hoisted_33 = {
  key: 1,
  class: "badge badge-red"
}
const _hoisted_34 = {
  key: 2,
  class: "badge badge-blue"
}
const _hoisted_35 = { class: "cell-slot-text" }
const _hoisted_36 = {
  key: 0,
  class: "info-container"
}
const _hoisted_37 = { class: "cell-title-container" }
const _hoisted_38 = { class: "cell-text-container" }
const _hoisted_39 = { class: "name-row" }
const _hoisted_40 = { class: "van-ellipsis name-slot" }
const _hoisted_41 = {
  key: 0,
  class: "badge badge-orange"
}
const _hoisted_42 = { class: "status-row" }
const _hoisted_43 = {
  key: 0,
  class: "badge badge-blue"
}
const _hoisted_44 = {
  key: 1,
  class: "badge badge-blue"
}
const _hoisted_45 = {
  key: 2,
  class: "badge badge-red"
}
const _hoisted_46 = {
  key: 3,
  class: "badge badge-blue"
}
const _hoisted_47 = { class: "cell-slot-text" }
const _hoisted_48 = { class: "cell-title-container" }
const _hoisted_49 = { class: "cell-text-container" }
const _hoisted_50 = { class: "name-row" }
const _hoisted_51 = { class: "van-ellipsis name-slot" }
const _hoisted_52 = {
  key: 0,
  class: "badge badge-orange"
}
const _hoisted_53 = { class: "status-row" }
const _hoisted_54 = {
  key: 0,
  class: "badge badge-blue"
}
const _hoisted_55 = {
  key: 1,
  class: "badge badge-blue"
}
const _hoisted_56 = {
  key: 2,
  class: "badge badge-red"
}
const _hoisted_57 = {
  key: 3,
  class: "badge badge-blue"
}
const _hoisted_58 = { class: "cell-slot-text" }
const _hoisted_59 = { class: "tab-container" }
const _hoisted_60 = { class: "cell-title-container" }
const _hoisted_61 = { class: "cell-text-container" }
const _hoisted_62 = { class: "name-row" }
const _hoisted_63 = { class: "van-ellipsis name-slot" }
const _hoisted_64 = {
  key: 0,
  class: "badge badge-orange"
}
const _hoisted_65 = { class: "status-row" }
const _hoisted_66 = {
  key: 0,
  class: "badge badge-blue"
}
const _hoisted_67 = {
  key: 1,
  class: "badge badge-blue"
}
const _hoisted_68 = {
  key: 2,
  class: "badge badge-red"
}
const _hoisted_69 = {
  key: 3,
  class: "badge badge-blue"
}
const _hoisted_70 = {
  key: 0,
  class: "badge badge-yellow"
}
const _hoisted_71 = {
  key: 1,
  class: "badge badge-yellow"
}
const _hoisted_72 = { class: "cell-slot-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_list, {
      loading: _ctx.loading,
      finished: _ctx.finished,
      "finished-text": _ctx.list.length === 0 ? '当前暂无数据，可修改筛选项后查看' : '没有更多了',
      onLoad: _ctx.onLoad,
      ref: "listContainer",
      onScroll: _ctx.scrollEvent
    }, {
      default: _withCtx(() => [
        (_ctx.tabType === _ctx.TabList.web)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.list, (item) => {
              return (_openBlock(), _createBlock(_component_van_cell, {
                key: item.id,
                "is-link": "",
                onClick: ($event: any) => (_ctx.goToDetailPage(_ctx.tabType, item))
              }, {
                title: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    (item.device === 'pc')
                      ? (_openBlock(), _createBlock(_component_van_image, {
                          key: 0,
                          class: "cell-image web-cell-image",
                          width: "40",
                          height: "40",
                          src: item.avatar || require('@/assets/img/computer.png')
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true),
                    (item.device === 'mobile')
                      ? (_openBlock(), _createBlock(_component_van_image, {
                          key: 1,
                          class: "cell-image web-cell-image",
                          width: "40",
                          height: "40",
                          src: item.avatar || require('@/assets/img/mobile.png')
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(item.feName), 1),
                        (item.has_user)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "已留资"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        (item.reply_status === 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (item.type === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "沉默"))
                                : _createCommentVNode("", true),
                              (item.type === 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "互动"))
                                : _createCommentVNode("", true),
                              (item.type === 2)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "开口"))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        (item.reply_status === 1)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (item.is_offline === 2)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "未读留言"))
                                : _createCommentVNode("", true),
                              (item.is_offline === 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "开口"))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        (item.reply_status === 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, "已读未回"))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tags || [], (tag) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: tag.id || tag.text,
                            class: "badge badge-gray"
                          }, _toDisplayString(tag.text), 1))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                "right-icon": _withCtx(() => [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(item.endTimeText), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          : _createCommentVNode("", true),
        (_ctx.tabType === _ctx.TabList.wechat)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.list, (item) => {
              return (_openBlock(), _createBlock(_component_van_cell, {
                key: item.id,
                "is-link": "",
                onClick: ($event: any) => (_ctx.goToDetailPage(_ctx.tabType, item))
              }, {
                title: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_van_image, {
                      class: "cell-image",
                      width: "40",
                      height: "40",
                      src: item.avatar || require('@/assets/img/wechat-avatars.png')
                    }, null, 8, ["src"]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(item.name), 1),
                        (item.has_user)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, "已留资"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        (item.reply_status === 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (item.type === 2)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, "开口"))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        (item.follow === 0 && ![2, 3].includes(item.app?.type))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, "已取关"))
                          : _createCommentVNode("", true),
                        (item.reply_status === 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, "未读未回"))
                          : _createCommentVNode("", true),
                        (item.reply_status === 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, "已读未回"))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tags || [], (tag) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: tag.id || tag.text,
                            class: "badge badge-gray"
                          }, _toDisplayString(tag.text), 1))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                "right-icon": _withCtx(() => [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(item.lastEventTimeText), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          : _createCommentVNode("", true),
        (_ctx.tabType === _ctx.TabList.weibo)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.list, (item) => {
              return (_openBlock(), _createBlock(_component_van_cell, {
                key: item.id,
                "is-link": "",
                onClick: ($event: any) => (_ctx.goToDetailPage(_ctx.tabType, item))
              }, {
                title: _withCtx(() => [
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_van_image, {
                      class: "cell-image",
                      width: "40",
                      height: "40",
                      src: item.avatar || require('@/assets/img/weibo-avatars.png')
                    }, null, 8, ["src"]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("span", _hoisted_29, _toDisplayString(item.name), 1),
                        (item.has_user)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, "已留资"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        (item.reply_status === 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (item.type === 2)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_32, "开口"))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        (item.reply_status === 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, "未读未回"))
                          : _createCommentVNode("", true),
                        (item.reply_status === 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, "已读未回"))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tags || [], (tag) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: tag.id || tag.text,
                            class: "badge badge-gray"
                          }, _toDisplayString(tag.text), 1))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                "right-icon": _withCtx(() => [
                  _createElementVNode("span", _hoisted_35, _toDisplayString(item.lastEventTimeText), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          : _createCommentVNode("", true),
        (_ctx.tabType === _ctx.TabList.douyin)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              (_ctx.showDouyinUpdateInfo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                return (_openBlock(), _createBlock(_component_van_cell, {
                  key: item.id,
                  "is-link": "",
                  onClick: ($event: any) => (_ctx.goToDetailPage(_ctx.tabType, item))
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_van_image, {
                        class: "cell-image",
                        width: "40",
                        height: "40",
                        src: item.avatar || require('@/assets/img/douyin-avatars.png')
                      }, null, 8, ["src"]),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("span", _hoisted_40, _toDisplayString(item.name), 1),
                          (item.has_user)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_41, "已留资"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          (item.reply_status === 0 && item.type === 2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_43, "开口"))
                            : _createCommentVNode("", true),
                          (item.reply_status === 0 && item.type === 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_44, "互动"))
                            : _createCommentVNode("", true),
                          (item.reply_status === 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_45, "未读未回"))
                            : _createCommentVNode("", true),
                          (item.reply_status === 2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_46, "已读未回"))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tags || [], (tag) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: tag.id || tag.text,
                              class: "badge badge-gray"
                            }, _toDisplayString(tag.text), 1))
                          }), 128))
                        ])
                      ])
                    ])
                  ]),
                  "right-icon": _withCtx(() => [
                    _createElementVNode("span", _hoisted_47, _toDisplayString(item.lastEventTimeText), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.tabType === _ctx.TabList.redbook)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(_ctx.list, (item) => {
              return (_openBlock(), _createBlock(_component_van_cell, {
                key: item.id,
                "is-link": "",
                onClick: ($event: any) => (_ctx.goToDetailPage(_ctx.tabType, item))
              }, {
                title: _withCtx(() => [
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_van_image, {
                      class: "cell-image",
                      width: "40",
                      height: "40",
                      src: item.avatar || require('@/assets/img/redbook-icon.png')
                    }, null, 8, ["src"]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("span", _hoisted_51, _toDisplayString(item.name), 1),
                        (item.has_user)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_52, "已留资"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        (item.reply_status === 0 && item.type === 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_54, "开口"))
                          : _createCommentVNode("", true),
                        (item.reply_status === 0 && item.type === 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_55, "互动"))
                          : _createCommentVNode("", true),
                        (item.reply_status === 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_56, "未读未回"))
                          : _createCommentVNode("", true),
                        (item.reply_status === 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_57, "已读未回"))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tags || [], (tag) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: tag.id || tag.text,
                            class: "badge badge-gray"
                          }, _toDisplayString(tag.text), 1))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                "right-icon": _withCtx(() => [
                  _createElementVNode("span", _hoisted_58, _toDisplayString(item.lastEventTimeText), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          : _createCommentVNode("", true),
        (_ctx.tabType === _ctx.TabList.kuaishou)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", {
                  class: _normalizeClass(["btn", { 'active': _ctx.kuaishouTab === 0 }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateKuaishouTab(0)))
                }, "私信访客", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["btn", { 'active': _ctx.kuaishouTab === 1 }]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateKuaishouTab(1)))
                }, "潜在访客", 2)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                return (_openBlock(), _createBlock(_component_van_cell, {
                  key: item.id,
                  "is-link": "",
                  onClick: ($event: any) => (_ctx.goToDetailPage(_ctx.tabType, item))
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("div", _hoisted_60, [
                      _createVNode(_component_van_image, {
                        class: "cell-image",
                        width: "40",
                        height: "40",
                        src: item.avatar || require('@/assets/img/kuaishou-icon.png')
                      }, null, 8, ["src"]),
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("span", _hoisted_63, _toDisplayString(item.name), 1),
                          (item.has_user)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_64, "已留资"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          (_ctx.kuaishouTab === 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (item.reply_status === 0 && item.type === 2)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_66, "开口"))
                                  : _createCommentVNode("", true),
                                (item.reply_status === 0 && item.type === 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_67, "互动"))
                                  : _createCommentVNode("", true),
                                (item.reply_status === 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_68, "未读未回"))
                                  : _createCommentVNode("", true),
                                (item.reply_status === 2)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_69, "已读未回"))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.kuaishouTab === 1)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (item.potential_type === 'live')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_70, "直播评论"))
                                  : _createCommentVNode("", true),
                                (item.potential_type === 'video')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_71, "视频评论"))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tags || [], (tag) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: tag.id || tag.text,
                              class: "badge badge-gray"
                            }, _toDisplayString(tag.text), 1))
                          }), 128))
                        ])
                      ])
                    ])
                  ]),
                  "right-icon": _withCtx(() => [
                    _createElementVNode("span", _hoisted_72, _toDisplayString(item.lastEventTimeText), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["loading", "finished", "finished-text", "onLoad", "onScroll"])
  ]))
}